import { Button, iconClose, IconSvg, responsiveVal } from '@graphcommerce/next-ui'
import play from '@graphcommerce/next-ui/icons/play.svg'
import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import { Box, Modal, Portal } from '@mui/material'

import { useEffect, useState } from 'react'

function getVideoId(url?: string | null) {
  if (!url) return false
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  const match = url.match(regExp)
  return match && match[7].length === 11 ? match[7] : false
}

export function ProductVideo(props: { youtubeUrl: string | null | undefined }) {
  const { youtubeUrl } = props
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      document
        .getElementById('youtube-video')
        ?.setAttribute('src', `https://www.youtube.com/embed/${getVideoId(youtubeUrl)}?autoplay=1`)
    })
  }, [open, youtubeUrl])

  if (!youtubeUrl) return null
  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => setOpen(false)

  return (
    <>
      <Button
        variant='text'
        color='primary'
        onClick={handleOpen}
        sx={(theme) => ({
          padding: '5px',
          mx: `calc(${theme.spacing(1)} / 2)`,
          borderRadius: '10px',
          display: 'flex',
          gap: '3px',
          '& .ProductVideo__text': {
            display: 'none',
          },
          [theme.breakpoints.only('xs')]: {
            '& .ProductVideo__text': {
              display: 'block',
            },
          },
          [theme.breakpoints.up('sm')]: {
            height: responsiveVal(35, 80),
            width: responsiveVal(35, 80),
            minWidth: 'unset !important',
          },
          fontSize: '16px !important',
        })}
      >
        <IconSvg fillIcon src={play} />
        <span className='ProductVideo__text'>
          <Trans id='View video' />
        </span>
      </Button>

      <Portal>
        <div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby='modal-modal-product-video'
            aria-describedby='modal-modal-product-video'
            sx={{
              display: 'flex',
              width: '100%',
              height: '100%',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={(theme) => ({
                maxWidth: '1280px',
                width: '100%',
                padding: theme.spacings.xs,
                background: theme.palette.background.paper,
                borderRadius: '5px',
              })}
            >
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  onClick={handleClose}
                  aria-label={i18n._(/* i18n */ 'Close')}
                  sx={(theme) => ({
                    boxShadow: 'none',
                    width: responsiveVal(40, 54),
                    height: responsiveVal(40, 54),
                    minWidth: 0,
                    borderRadius: 999,
                    marginRight: `calc(calc(${theme.spacings.xs} / 2) * -1)`,
                    marginTop: `calc(calc(${theme.spacings.xs} / 2) * -1)`,
                    marginBottom: `calc(${theme.spacings.xs} / 2)`,
                  })}
                >
                  <IconSvg src={iconClose} size='large' />
                </Button>
              </Box>
              <Box
                sx={{
                  position: 'relative',
                  overflow: 'hidden',
                  width: '100%',
                  paddingTop: '56.25%',
                }}
              >
                <iframe
                  title='Youtube Video'
                  src=''
                  frameBorder='0'
                  id='youtube-video'
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    width: '100%',
                    height: '100%',
                  }}
                  allowFullScreen
                />
              </Box>
            </Box>
          </Modal>
        </div>
      </Portal>
    </>
  )
}
